import React from 'react';
import { LayoutDashboardIcon, MapIcon, BriefcaseIcon, BellIcon, UserIcon } from 'lucide-react';
interface BottomNavProps {
  currentPage: string;
  navigate: (page: string) => void;
  notificationCount: number;
  t: (key: string) => string;
}
export function BottomNav({
  currentPage,
  navigate,
  notificationCount,
  t
}: BottomNavProps) {
  const navItems = [{
    id: 'dashboard',
    label: t('nav.dashboard'),
    icon: LayoutDashboardIcon
  }, {
    id: 'mylands',
    label: t('nav.mylands'),
    icon: MapIcon
  }, {
    id: 'services',
    label: t('nav.services'),
    icon: BriefcaseIcon
  }, {
    id: 'notifications',
    label: t('nav.notifications'),
    icon: BellIcon,
    badge: notificationCount
  }, {
    id: 'profile',
    label: t('nav.profile'),
    icon: UserIcon
  }];
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-40 pb-safe" data-id="element-30">
      <div className="flex justify-around items-center h-16" data-id="element-31">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = currentPage === item.id || currentPage === 'landdetails' && item.id === 'mylands';
        return <button key={item.id} onClick={() => navigate(item.id)} className={`relative flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-[#006A4E]' : 'text-slate-500 hover:text-slate-800'}`} data-id="element-32">
              <div className="relative" data-id="element-33">
                <Icon className={`w-6 h-6 ${isActive ? 'fill-[#006A4E]/10' : ''}`} data-id="element-34" />
                {item.badge > 0 && <span className="absolute -top-1 -right-1 bg-[#C8102E] text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full border-2 border-white" data-id="element-35">
                    {item.badge}
                  </span>}
              </div>
              <span className="text-[10px] font-medium truncate w-full text-center px-1" data-id="element-36">
                {item.label}
              </span>
            </button>;
      })}
      </div>
    </div>;
}